import { NAVIGATION } from './actionTypes';
import { actionCreator } from './index';
import { ModalComponentNames, ModalInterface } from '../Interfaces/ModalInterface';

export const navigateAddModal = actionCreator<ModalInterface>(NAVIGATION.ADD_MODAL);
export const navigateRemoveModal = actionCreator<ModalComponentNames>(NAVIGATION.REMOVE_MODAL);
